module.exports = __webpack_public_path__ + "static/33-c0f84e58de769a6f4bf401fa08ccafd1.jpg";